import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import { I18N } from 'commons';
import FieldErrorMessage from 'components/forms/FieldErrorMessage';
import { orgId } from 'utils';

const UserNameFieldSection = ({
  name, type, title, className, isOptional, values, touched, errors,
  isDisable, setFieldValue, setFieldTouched, setFieldError, ...props
}) => {
  const hasTouched = _.has(touched, 'username') && touched.username === true;
  const hasError = _.has(errors, 'username') && errors.username !== '';
  return (
    <div className={className}>
      <label className="col-form-label" htmlFor={name} id={`${name}Label`}>

        <I18N>{title}</I18N>
        {
          !isOptional &&
          <span aria-hidden="true" className="required-star">*</span>
        }
        {
          !isOptional &&
          <span className="sr-only"><I18N>information.label.required</I18N></span>
        }
      </label>
      <div>
        <Field
          autoComplete="off"
          disabled={isDisable}
          type={type}
          name={name}
          id={name}
          aria-labelledby={`${name}Label`}
          aria-describedby={`${(hasTouched && hasError) ? `${name}Desc` : ''} ${name}Tip`}
          className="form-control"
          value={values[name]}
          aria-invalid={hasTouched && hasError}
          onChange={e => {
            setFieldValue('username', e.target.value, false);
            setFieldTouched('username', false, false);
            setFieldError('username', '');
          }}
          {...props}
        />
      </div>
      {
        hasTouched && hasError &&
        <FieldErrorMessage id={`${name}Desc`} aria-labelledby={`${name}Label`}>
          <I18N i18n={{ 0: 4, orgId, username: values[name] }}>{errors[name]}</I18N>
        </FieldErrorMessage>
      }
    </div>
  );
};

UserNameFieldSection.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  type: PropTypes.string,
  isOptional: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
};

UserNameFieldSection.defaultProps = {
  type: 'text',
  isOptional: false,
};

export default UserNameFieldSection;
